import { computedDirectiveTransformer } from './computedDirectiveTransformer';
export { computedDirectiveTransformer } from './computedDirectiveTransformer';
export const defaultSubschemaConfigTransforms = [computedDirectiveTransformer('computed')];
//# sourceMappingURL=index.js.map